import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	netoChatOne: 3,
	clientChatOne: 4,
	netoChatTwo: 5,
	showMonitor: 6,
	netoChatThree: 7,
	clientChatTwo: 8,
	netoChatFour: 9,
	winSubactivityFour: 10,
}
export const Tema4SubtopicFourActivityFour = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema4], 4);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema4 activity 4");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 4);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 4: Cancelación de productos." />
					<DialogBarNew
						dialog={
							"Hasta el momento vas muy bien. Continúa atendiendo a este Cliente para obtener puntos."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Cobro de productos"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.netoChatOne);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.netoChatOne && (
				<>	<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Hola, buen día. Bienvenida ¿Cómo le puedo ayudar?"
						}
						callback={() => {
							setUiToShow(steps.clientChatOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.amandaWithCoke} alt="Amanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Amanda"
						dialog={
							"Buen día. Me estaría llevando esto."
						}
						callback={() => {
							setUiToShow(steps.netoChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a04)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Claro."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.showMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFour.img3monitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a05)
							setUiToShow(steps.showMonitor);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.showMonitor && (
				<>
					<DialogBarNew
						name="Neto"
						dialog={
							"Comenzare a marcar."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a06)
							setUiToShow(steps.netoChatThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Son $10 pesos."
						}
						callback={() => {
							setUiToShow(steps.clientChatTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a07)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.amanda} alt="Amanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Amanda"
						dialog={
							"Siempre no me lo llevo."
						}
						callback={() => {
							setUiToShow(steps.netoChatFour);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act4_a08)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoChatFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"De acuerdo."
						}
						callback={() => {
							setUiToShow(steps.winSubactivityFour);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winSubactivityFour && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="¡Excelente atención al cliente! Tu dedicación y profesionalismo son impresionantes."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: 0,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							navigation("/home4/tema4/subtema4/activityFive");
						}}
					/>
				</>
			)}
		</>
	)
}
